/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */

import './firewall.scss';

/* eslint-disable import/no-unresolved, import/default */

import firewallTemplate from './firewall.tpl.html';
import filterDialogTemplate from './filter-dialog.tpl.html';

/* eslint-enable import/no-unresolved, import/default */

export default angular.module('tektelic.firewall', [])
    .directive('tkGatewayFirewall', GatewayFirewall)
    .name;

/*@ngInject*/
function GatewayFirewall() {
    return {
        restrict: "E",
        scope: true,
        bindToController: {
            gatewayId: '=',
            isReadOnly: '='
        },
        controller: GatewayFirewallController,
        controllerAs: 'vm',
        templateUrl: firewallTemplate
    };
}

/*@ngInject*/
function GatewayFirewallController($rootScope, $scope, $element, $mdDialog, $document, toast, gatewayCommandService, $mdExpansionPanel, types) {

    var vm = this;

    vm.$onInit = function () {
        vm.types = types;
        vm.$mdExpansionPanel = $mdExpansionPanel;

        vm.getFirewallConfiguration = getFirewallConfiguration;
        vm.setFirewallConfiguration = setFirewallConfiguration;

        vm.insertFilter = insertFilter;
        vm.appendFilter = appendFilter;
        vm.moveFilterUp = moveFilterUp;
        vm.moveFilterDown = moveFilterDown;
        vm.editFilter = editFilter;
        vm.viewFilter = viewFilter;

        vm.onRowClick = onRowClick;
        vm.isCurrent = isCurrent;

        vm.loading = function () {
            return $rootScope.loading;
        };
    };

    $scope.$watch('vm.gatewayId', (newVal) => {
        if (newVal) {
            reload();
        }
    });

    function reload() {
        vm.firewallConfiguration = {
            filters: [],
            ping: {},
            ssh: {},
            doSPrevention: {}
        };
        vm.currentFilter = null;
    }

    function getFirewallConfiguration() {
        vm.firewallConfigurationPromise = gatewayCommandService.executeCommand(vm.gatewayId.id,
            types.firewallGatewayCommand.getFirewallConfiguration.value, {});
        vm.firewallConfigurationPromise.then(
            (configuration) => {
                vm.firewallConfiguration = configuration;
                if (!vm.firewallConfiguration.filters) {
                    vm.firewallConfiguration.filters = [];
                }
                if (!vm.firewallConfiguration.ping) {
                    vm.firewallConfiguration.ping = {}
                }
                if (!vm.firewallConfiguration.ssh) {
                    vm.firewallConfiguration.ssh = {}
                }
                if (!vm.firewallConfiguration.doSPrevention) {
                    vm.firewallConfiguration.doSPrevention = {}
                }
                vm.currentFilter = null;
            },
            (rejection) => {
                toast.showError(rejection.data, $element.closest(".toast-parent"), 'bottom left');
            }
        );
    }

    function setFirewallConfiguration() {
        vm.firewallConfigurationPromise = gatewayCommandService.executeCommand(vm.gatewayId.id,
            types.firewallGatewayCommand.setFirewallConfiguration.value, vm.firewallConfiguration);
        vm.firewallConfigurationPromise.then(
            () => {
                getFirewallConfiguration();
            },
            (rejection) => {
                toast.showError(rejection.data, $element.closest(".toast-parent"), 'bottom left');
            }
        );
    }

    function insertFilter($event) {
        var index = vm.firewallConfiguration.filters.indexOf(vm.currentFilter);
        openFilterDialog($event).then(
            (filter) => {
                if (index > -1) {
                    vm.firewallConfiguration.filters.splice(index, 0, filter);
                } else {
                    vm.firewallConfiguration.filters.push(filter);
                }
            }
        );
    }

    function appendFilter($event) {
        openFilterDialog($event).then(
            (filter) => {
                vm.firewallConfiguration.filters.push(filter);
            }
        );
    }

    function moveFilterUp() {
        if (vm.currentFilter) {
            var index = vm.firewallConfiguration.filters.indexOf(vm.currentFilter);
            if (index > 0) {
                vm.firewallConfiguration.filters.splice(index, 1);
                index--;
                vm.firewallConfiguration.filters.splice(index, 0, vm.currentFilter);
            }
        }
    }

    function moveFilterDown() {
        if (vm.currentFilter) {
            var index = vm.firewallConfiguration.filters.indexOf(vm.currentFilter);
            if (index < vm.firewallConfiguration.filters.length-1) {
                vm.firewallConfiguration.filters.splice(index, 1);
                index++;
                vm.firewallConfiguration.filters.splice(index, 0, vm.currentFilter);
            }
        }
    }

    function editFilter($event, filter) {
        var index = vm.firewallConfiguration.filters.indexOf(filter);
        openFilterDialog($event, filter).then(
            (filter) => {
                vm.firewallConfiguration.filters[index] = filter;
                vm.currentFilter = filter;
            }
        );
    }

    function viewFilter($event, filter) {
        openFilterDialog($event, filter);
    }

    function onRowClick($event, filter) {
        if ($event) {
            $event.stopPropagation();
        }
        if (vm.currentFilter != filter) {
            vm.currentFilter = filter;
        }
    }

    function isCurrent(filter) {
        return (vm.currentFilter && filter) &&
            (vm.currentFilter === filter);
    }

    function openFilterDialog($event, filter) {
        if ($event) {
            $event.stopPropagation();
        }
        return $mdDialog.show({
            controller: FilterDialogController,
            controllerAs: 'vm',
            templateUrl: filterDialogTemplate,
            parent: angular.element($document[0].body),
            locals: {
                isReadOnly: vm.isReadOnly,
                filter: angular.copy(filter)
            },
            fullscreen: true,
            skipHide: true,
            targetEvent: $event
        });
    }

}

/*@ngInject*/
function FilterDialogController($rootScope, $scope, $mdDialog, types, isReadOnly, filter) {

    var vm = this;

    vm.$onInit = function () {
        vm.isReadOnly = isReadOnly;
        if (!filter) {
            vm.filter = {
                enabled: true,
                chain: types.firewall.chain.input,
                target: types.firewall.target.accept
            };
            vm.isAdd = true;
        } else {
            vm.filter = filter;
            vm.isAdd = false;
        }

        vm.types = types;

        vm.saveFilter = saveFilter;
        vm.cancel = cancel;

        vm.loading = function () {
            return $rootScope.loading;
        };
    };

    function cancel() {
        $mdDialog.cancel();
    }

    function saveFilter() {
        $scope.theForm.$setPristine();
        $mdDialog.hide(vm.filter);
    }

}



// WEBPACK FOOTER //
// ./src/app/gateway/firewall/firewall.directive.js